import type { IconDef } from '../types';

export const statsFilled: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M18 1H6C3.24 1 1 3.24 1 6V18C1 20.76 3.24 23 6 23H18C20.76 23 23 20.76 23 18V6C23 3.24 20.76 1 18 1ZM8.83 15.87C8.81 16.42 8.34 16.85 7.79 16.83C7.24 16.81 6.81 16.34 6.83 15.79L7.06 10.55C7.08 10 7.55 9.57 8.1 9.59C8.65 9.61 9.08 10.08 9.06 10.63L8.83 15.87ZM12.83 16.04C12.81 16.59 12.34 17.02 11.79 17C11.24 16.98 10.81 16.51 10.83 15.96L11.18 7.97C11.2 7.42 11.67 6.99 12.22 7.01C12.77 7.03 13.2 7.5 13.18 8.05L12.83 16.04ZM16.83 16.21C16.81 16.76 16.34 17.19 15.79 17.17C15.24 17.15 14.81 16.68 14.83 16.13L14.94 13.53C14.96 12.98 15.43 12.55 15.98 12.57C16.53 12.59 16.96 13.06 16.94 13.61L16.83 16.21Z',
    },
  ],
};
